const certify = {
  isTurnDown: false, //是否驳回
  companyType: '0001',
  businessLicense: '002008',
  comVeriStatus: {}
}

export default certify
